var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chapter-title"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.contentItem.title)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }